{
  "Accessibility Menu": "Menu ng Accessibility",
  "Reset settings": "I-reset ang mga setting",
  "Close": "Isara",
  "Content Adjustments": "Ayusin ang Nilalaman",
  "Adjust Font Size": "I-adjust ang Laki ng Font",
  "Highlight Title": "I-highlight ang Pamagat",
  "Highlight Links": "I-highlight ang mga Link",
  "Readable Font": "Madaling Basahing Font",
  "Color Adjustments": "Ayusin ang Kulay",
  "Dark Contrast": "Madilim na Pagkakaiba",
  "Light Contrast": "Maliwanag na Pagkakaiba",
  "High Contrast": "Mataas na Pagkakaiba",
  "High Saturation": "Mataas na Saturation",
  "Low Saturation": "Mababang Saturation",
  "Monochrome": "Monokrom",
  "Contrast": "Kontrasta",
  "Invert Colors": "Baliktarin ang mga kulay",
  "Tools": "Mga Kasangkapan",
  "Reading Guide": "Gabay sa Pagbabasa",
  "Stop Animations": "Itigil ang Mga Animasyon",
  "Big Cursor": "Malaking Cursor",
  "Increase Font Size": "Palakihin ang Laki ng Font",
  "Decrease Font Size": "Bawasan ang Laki ng Font",
  "Letter Spacing": "Espasyo ng mga Titik",
  "Line Height": "Taas ng Linya",
  "Font Weight": "Bigat ng Font",
  "Dyslexia Font": "Font para sa Dyslexia",
  "Language": "Wika",
  "Open Accessibility Menu": "Buksan ang Menu ng Accessibility",
  "Widget Settings": "Mga setting ng widget",
  "Widget Position": "Posisyon ng widget",
  "Top Left": "Itas-kaliwa",
  "Top Center": "Itas-gitna",
  "Top Right": "Itas-kanan",
  "Center Left": "Gitna-kaliwa",
  "Center Right": "Gitna-kanan",
  "Bottom Left": "Ibaba-kaliwa",
  "Bottom Center": "Ibaba-gitna",
  "Bottom Right": "Ibaba-kanan",
  "Screen Reader": "Screen reader",
  "Voice Navigation": "Voice navigation",
  "Custom Color": "Pasadyang kulay",
  "Change the site's colors": "Palitan ang mga kulay ng site",
  "Backgrounds": "Mga background",
  "Headings": "Mga heading",
  "Contents": "Nilalaman",
  "Reset colors": "I-reset ang mga kulay",
  "Image Desaturation": "Pagbawas ng kulay ng larawan",
  "Search languages": "Maghanap ng mga wika",
  "No languages found": "Walang nahanap na wika",
  "Accessibility Profiles": "Mga profile ng accessibility",
  "Motor Impaired": "May kapansanan sa paggalaw",
  "Big cursor, voice navigation, and no animations.": "Malaking cursor, voice navigation at walang animasyon.",
  "Blind": "Bulag",
  "Screen reader helpers with higher contrast.": "Mga tulong sa screen reader na may mas mataas na contrast.",
  "Color Blind": "Color blind",
  "High contrast palette with desaturated media.": "Palette na may mataas na contrast at bahagyang kulay.",
  "Dyslexia": "Dislexia",
  "Friendly font, extra spacing, stronger weight.": "Madaling basahin na font, dagdag na pagitan at mas makapal na bigat.",
  "Low vision": "Mahinang paningin",
  "Dark contrast and 130% magnification.": "Madilim na contrast at 130% na pagpapalaki.",
  "Cognitive & Learning": "Kognitibo at pagkatuto",
  "Highlights key sections and enables voice help.": "Inililinaw ang mahahalagang seksyon at pinapagana ang voice help.",
  "Seizure & Epileptic": "Pangingisay at epilepsy",
  "Stops animations and desaturates imagery.": "Humihinto ng mga animasyon at binabawasan ang kulay ng imahe.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Gabay sa pagbabasa, naka-highlight na mga link at mas kalmadong palette.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
